import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  // mode: 'history',
  routes: [

    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/views/Index.vue'], resolve),
      meta: {
        title: '首页',
        keepAlive: true,
        content: {
          keywords: '南京斯图加特联合展览有限公司,斯图加特,物流展,amtech,educationplus,education+,hlc,南京主材展,主材展,messenanjing,南京展览,展览,南京国际博览中心,南京国博,国博,cmtc,度假房车,房车展,南京旅游展,江苏旅游展,创新周,南京创新周,南京创新大会,创新大会,房车,旅游,会展,主办',
          description: '德国逾百年专业展览公司，运营南京国际博览中心场地，主办、承办各类专业展',
        },
      }
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: resolve => require(['@/views/Aboutus.vue'], resolve),
      meta: {
        title: '关于我们',
        keepAlive: true,
        content: {
          keywords: '南京斯图加特联合展览有限公司,斯图加特,物流展,amtech,educationplus,education+,hlc,南京主材展,主材展,messenanjing,南京展览,展览,南京国际博览中心,南京国博,国博,cmtc,度假房车,房车展,南京旅游展,江苏旅游展,创新周,南京创新周,南京创新大会,创新大会,房车,旅游,会展,主办',
          description: '德国逾百年专业展览公司，运营南京国际博览中心场地，主办、承办各类专业展',
        },
      }
    },
    {
      path: '/exhibtions',
      name: 'exhibtions',
      component: resolve => require(['@/views/Exhibtions.vue'], resolve),
      meta: {
        title: '展览',
        keepAlive: true,
        content: {
          keywords: '南京斯图加特联合展览有限公司,斯图加特,物流展,amtech,educationplus,education+,hlc,南京主材展,主材展,messenanjing,南京展览,展览,南京国际博览中心,南京国博,国博,cmtc,度假房车,房车展,南京旅游展,江苏旅游展,创新周,南京创新周,南京创新大会,创新大会,房车,旅游,会展,主办',
          description: '德国逾百年专业展览公司，运营南京国际博览中心场地，主办、承办各类专业展',
        },
      }
    },
    {
      path: '/venuereservation',
      name: 'venuereservation',
      component: resolve => require(['@/views/Venuereservation.vue'], resolve),
      meta: {
        title: '场地预订',
        keepAlive: true,
        content: {
          keywords: '南京斯图加特联合展览有限公司,斯图加特,物流展,amtech,educationplus,education+,hlc,南京主材展,主材展,messenanjing,南京展览,展览,南京国际博览中心,南京国博,国博,cmtc,度假房车,房车展,南京旅游展,江苏旅游展,创新周,南京创新周,南京创新大会,创新大会,房车,旅游,会展,主办',
          description: '德国逾百年专业展览公司，运营南京国际博览中心场地，主办、承办各类专业展',
        },
      }
    },
    {
      path: '/mediacenter',
      name: 'mediacenter',
      component: resolve => require(['@/views/Mediacenter.vue'], resolve),
      meta: {
        title: '媒体中心',
        keepAlive: true,
        content: {
          keywords: '南京斯图加特联合展览有限公司,斯图加特,物流展,amtech,educationplus,education+,hlc,南京主材展,主材展,messenanjing,南京展览,展览,南京国际博览中心,南京国博,国博,cmtc,度假房车,房车展,南京旅游展,江苏旅游展,创新周,南京创新周,南京创新大会,创新大会,房车,旅游,会展,主办',
          description: '德国逾百年专业展览公司，运营南京国际博览中心场地，主办、承办各类专业展',
        },
      }
    },
    {
      path: '/joinus',
      name: 'joinus',
      component: resolve => require(['@/views/Joinus.vue'], resolve),
      meta: {
        title: '加入我们',
        keepAlive: true,
        content: {
          keywords: '南京斯图加特联合展览有限公司,斯图加特,物流展,amtech,educationplus,education+,hlc,南京主材展,主材展,messenanjing,南京展览,展览,南京国际博览中心,南京国博,国博,cmtc,度假房车,房车展,南京旅游展,江苏旅游展,创新周,南京创新周,南京创新大会,创新大会,房车,旅游,会展,主办',
          description: '德国逾百年专业展览公司，运营南京国际博览中心场地，主办、承办各类专业展',
        },
      }
    }
  ]
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js